export class MultiApplicantPlaceholder {
  public ApplicantName: string;
  public PlaceholderId: number;
}
